export enum PaymentFrequencyTypeEnum {
  weekly = 'weekly',
  fortnightly = 'fortnightly',
  bimonthly = 'bimonthly',
  monthly = 'monthly',
  quarterly = 'quarterly',
  yearly = 'yearly',
  every_second_month = 'every_second_month',
}

export enum PaymentTypeEnum {
  loan = 'loan',
  cash = 'cash',
  lease = 'lease',
  regular_payment = 'regular_payment',
  loan_advanced = 'loan_advanced',
  ppa = 'ppa',
  prepaid_lease = 'prepaid_lease',
  prepaid_ppa = 'prepaid_ppa',
}

export const isPrepaidPaymentType = (paymentType: PaymentTypeEnum | string) =>
  paymentType === PaymentTypeEnum.prepaid_lease || paymentType === PaymentTypeEnum.prepaid_ppa

export const isCashLikePaymentType = (paymentType: PaymentTypeEnum | string) =>
  paymentType === PaymentTypeEnum.cash || isPrepaidPaymentType(paymentType)